import { Auth as AmplifyAuth } from '@aws-amplify/auth';
import jwtDecode from 'jwt-decode';
import { CognitoConfig } from './CognitoConfig';
type JwtPayload = { sub?: string; preferred_username?: string; username?: string; email?: string; [k: string]: any };

const SESSION_KEY = 'gobotCognitoAccessToken';
const SESSION_ALIAS_KEY = 'gobotCognitoAlias';

let configured = false;
function ensureConfigured() {
  if (!configured) {
    AmplifyAuth.configure(CognitoConfig);
    configured = true;
  }
}

function cacheSet(token: string, alias: string) {
  try { sessionStorage.setItem(SESSION_KEY, token); } catch {}
  try { sessionStorage.setItem(SESSION_ALIAS_KEY, alias); } catch {}
}
function cacheGet(): { accessToken: string; alias: string } | null {
  try {
    const t = sessionStorage.getItem(SESSION_KEY);
    const a = sessionStorage.getItem(SESSION_ALIAS_KEY);
    if (t && a) return { accessToken: t, alias: a };
  } catch {}
  return null;
}

function aliasFromJwt(jwt: string): string {
  try {
    const p = jwtDecode<JwtPayload>(jwt) || {};
    return (p.preferred_username as string) || (p.username as string) || (p.email as string) || (p.sub as string) || '';
  } catch { return ''; }
}

function stripOauthParams() {
  const url = new URL(window.location.href);
  ['code', 'state', 'error', 'error_description'].forEach(k => url.searchParams.delete(k));
  const next = url.toString();
  if (next !== window.location.href) window.history.replaceState({}, '', next);
}

export async function getCognitoJwtForGobot():
    Promise<{ accessToken: string; alias: string } | null> {

  const cached = cacheGet();
  if (cached?.accessToken) return cached;

  try {
    ensureConfigured();

    const session = await AmplifyAuth.currentSession();

    const accessToken = session.getAccessToken().getJwtToken();
    const alias =
        aliasFromJwt(accessToken) ||
        (session.getIdToken()?.payload?.['cognito:username'] as string) ||
        (session.getIdToken()?.payload?.['email'] as string) || '';

    cacheSet(accessToken, alias);
    stripOauthParams();
    return { accessToken, alias };

  } catch {
    const qp = new URLSearchParams(window.location.search);
    const oauthError = qp.get('error');

    if (oauthError) {
      stripOauthParams();
      sessionStorage.setItem('gobotSilentTried', '1');
      AmplifyAuth.federatedSignIn();
      return null;
    }

    const FLAG = 'gobotCognitoLoginStarted';
    if (!sessionStorage.getItem(FLAG)) {
      sessionStorage.setItem(FLAG, '1');
      sessionStorage.setItem('gobotReturnTo', location.href);
      AmplifyAuth.federatedSignIn(); // urlOpener adds prompt=none on first attempt
    }
    return null;
  }
}

